<template>
    <el-container>
        <div class="singleListDiv">
            <div>
                <el-row>
                    <td-input class="conshow" :width="180" :placeholder="$t(inputName)" v-model="filterText"></td-input>
                </el-row>
            </div>
            <div style="width:255px;height:300px;overflow:auto;overscroll-behavior: contain;-ms-scroll-chaining: contain;">
                <el-row v-if="hasShowTitle">
                    <span>{{ titleName }}</span>
                </el-row>
                <el-row v-if="upperShow">
                    <el-link @click.native="upperClick" :underline="false" v-loading="upperloading"
                        ><img :src="upperLevel" style="padding-left:15px;padding-right:5px;width:15px;height:15px" />{{ $t('role.UPPER_LEVEL') }}</el-link
                    >
                </el-row>
                <el-row>
                    <el-table
                        v-loading.iTable="tableLoading"
                        ref="elTableRef"
                        :row-key="rowKey"
                        :show-header="true"
                        v-infinite-scroll="scrollLoad"
                        :infinite-scroll-disabled="busy"
                        infinite-scroll-distance="0"
                        :infinite-scroll-immediate="immediateScroll"
                        highlight-current-row
                        :data="formatData == null ? [] : formatData"
                        @select="_handleSelect"
                        @select-all="_handleSelectAll"
                        @selection-change="_handSelectionChange"
                        @row-click="_handRowClick"
                        @row-dblclick="_handRowDblclick"
                        @cell-mouse-enter="_handCellMouseEnter"
                        @cell-mouse-leave="_handCellMouseLeave"
                        @cell-click="_handCellClick"
                        @cell-dblclick="_handCellDblclick"
                        @row-contextmenu="_handRowContextmenu"
                        @current-change="_handCurrentChange"
                    >
                        <el-table-column v-if="hasMutiSelect" type="selection" width="45"> </el-table-column>
                        <el-table-column :prop="columnObj.prop" :label="vm.$t(columnObj.label)">
                            <template slot-scope="scope">
                                <my-render :row="scope.row" :render="columnObj.render" :index="scope.$index"></my-render>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="hasOperational" :width="operateColumn.width" :align="operateColumn.align">
                            <template slot-scope="scope">
                                <my-render :row="scope.row" :render="operateColumn.render" :index="scope.$index"></my-render>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-row>
                <el-row v-if="isPage" style="padding-top:10px;padding-bottom:5px;">
                    <el-col style="width:100px;padding-left:35px">
                        <td-button size="mini" @click="before" :disabled="currentPage == 1">{{ $t('role.BEFORE') }}</td-button>
                    </el-col>
                    <el-col style="width:80px;padding-left:20px">
                        <td-button size="mini" @click="next" :disabled="nextDisable">{{ $t('role.NEXT') }}</td-button>
                    </el-col>
                </el-row>
            </div>
        </div>
    </el-container>
</template>
<script>
import Sortable from 'sortablejs';
export default {
    /* 引用渲染函数 */
    components: {
        MyRender: {
            functional: true,
            props: {
                row: Object,
                render: Function
            },
            render: (h, ctx) => {
                const params = {
                    row: ctx.props.row,
                    index: ctx.props.index
                };
                if (ctx.props.column) params.column = ctx.props.column;
                return ctx.props.render(h, params);
            }
        }
    },
    /* 接受父组件参数 */
    props: {
        upperloading: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        popFlag: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        currentPage: {
            type: Number,
            default: function() {
                return 1;
            }
        },
        isPage: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        nextDisable: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        upperShow: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        defauleProps: {
            type: Object,
            default: function() {
                return { key: 'key', label: 'label', permissionStr: 'sPermissionStr', resType: 'resType' };
            }
        },
        //是否显示标题
        hasShowTitle: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        //标题名称
        titleName: String,
        //列表数据对象
        columnObj: {
            type: Object,
            default: function() {
                return {
                    id: 'id',
                    prop: 'caption'
                };
            }
        },

        //是否显示操作项
        hasOperational: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        //操作对象
        operateColumn: {
            type: Object,
            default: function() {
                return {
                    width: '90',
                    align: 'center'
                };
            }
        },
        // 列表是否懒加载,默认懒加载
        lazyloading: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 搜索框是否显示
        inputShow: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 搜索框默认显示内容
        inputName: {
            type: String,
            default: function() {
                return 'component.PLEASE_ENTER_KEYWORD';
            }
        },
        // 搜索框宽度
        inputWidth: {
            type: Number,
            default: function() {
                return 200;
            }
        },
        // 是否使用组件内部方法获取单列表数据
        calInternal: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 接口地址
        interfaceName: {
            type: Object,
            default: function() {
                return {
                    query: '',
                    search: ''
                };
            }
        },
        /* 是否默认选中第一行 */
        hasDefaultSelection: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        /* 是否加载添加按钮 */
        hasAddElement: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        /* 是否加载多选框 */
        hasMutiSelect: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        /*  单列表高度 */
        height: {
            type: Number,
            default: function() {
                if (this.inputShow) {
                    return window.innerHeight - 320;
                }
                return window.innerHeight - 180;
            }
        },
        /*  单列表宽度*/
        width: {
            type: Number,
            default: function() {
                return window.innerWidth;
            }
        },
        /* 是否加载分页 */
        hasPage: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        /* 是否使用mini分页 （侧重尺寸） */
        smallPage: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        /* 表格数据源 表格主题数据 */
        dataSource: {
            type: [Array, Object],
            default: function() {
                return [];
            }
        },
        /*  每页条数 */
        pageSize: {
            type: Number,
            default: function() {
                return 30;
            }
        },
        /* 总条数 */
        total: {
            type: Number,
            default: function() {
                return 0;
            }
        },
        /* 是否支持行拖拽 */
        isDraggable: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        /* 唯一行标示，在进行表格拖拽时必填属性 */
        rowKey: [String, Function],
        /* 是否开启翻页记忆 */
        hasPageMemory: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        /* 所有权限信息 */
        permissions: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 角色信息 */
        roles: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 权限之一 */
        oneOfPermissions: {
            type: Array,
            default: function() {
                return [];
            }
        },
        token: {
            type: String
        },
        tableLoading: {
            type: Boolean
        },
        roleType: {
            type: String
        }
    },
    computed: {
        // 格式化数据源
        formatData: function() {
            this.clear();
            if (Math.ceil(this.total / this.pageSize) > 0 && Math.ceil(this.total / this.pageSize) < this.currentPage) {
                this.$emit('pagCurrentChange', Math.ceil(this.total / this.pageSize));
            }
            return this.dataSource;
        }
    },
    watch: {
        tableData: {
            handler: function() {
                setTimeout(() => {
                    try {
                        this._setSelectRow();
                        if (this.hasDefaultSelection) {
                            this.defaultSelection();
                        }
                        if (this.isDraggable) {
                            this.setDragSort();
                        }
                    } catch (error) {
                        console.log('error:' + error);
                    }
                }, 200);
            },
            deep: true,
            // immediate表示在watch中首次绑定的时候，是否执行handler，值为true则表示在watch中声明的时候，就立即执行handler方法，
            // 值为false，则和一般使用watch一样，在数据发生变化的时候才执行handler。
            immediate: true
        },
        formatData: {
            handler: function() {
                setTimeout(() => {
                    try {
                        this._setSelectRow();
                        if (this.hasDefaultSelection) {
                            this.defaultSelection();
                        }
                        if (this.isDraggable) {
                            this.setDragSort();
                        }
                    } catch (error) {
                        console.log('error:' + error);
                    }
                }, 200);
            },
            deep: true,
            // immediate表示在watch中首次绑定的时候，是否执行handler，值为true则表示在watch中声明的时候，就立即执行handler方法，
            // 值为false，则和一般使用watch一样，在数据发生变化的时候才执行handler。
            immediate: true
        }
    },
    data() {
        return {
            onpresscTime: 0, //  阻止短时间内连续点击
            filterText: '', //搜索内容
            busy: false, //是否禁用滚动
            immediateScroll: true, //是否立即执行加载方法
            isIndeterminate: false, // 全选checkbox 的不确定状态
            tableData: [], // 懒加载数据列表
            multipleSelection: [], // 当前页选中的数据
            multipleSelectionAll: [], // 所有选中的数据包含跨页数据
            checkAll: false, //全选状态
            tableDataMap: new Map(), //列表数据集合
            scrollPage: 1, //滚动当前页,
            isSelectAll: true,
            vm: window.vue
        };
    },
    created() {
        this.upperLevel = 'auth/' + window.vue.$store.state.skin + '/img/upperLevel.png';
    },
    mounted() {
        this.$watch(
            'filterText',
            this.$util.delayExcute(newQuery => {
                // 输入结束后，延时0.5秒执行查询
                if (this.lazyloading) {
                    this.tableData.length = 0;
                    this.scrollPage = 1;
                    this.scrollLoad();
                }
                this.$emit('filterQuery', this.filterText);

            }, 500)
        );
    },
    methods: {
        clearfilterText() {
            this.filterText = '';
        },
        before() {
            this.$emit('before');
        },
        next() {
            this.$emit('next');
        },
        //返回上一级
        upperClick() {
            this.upperloading = true;
            if (Date.now() - this.onpresscTime > 300) {
                this.onpresscTime = Date.now();
                this.$emit('upperClick');
            }
        },
        //默认选中
        defaultSelection() {
            this.$refs.elTableRef.setCurrentRow(this.$refs.elTableRef.data[0]);
        },
        clear() {
            this.multipleSelection = [];
        },
        // 行拖拽
        setDragSort() {
            let _this = this;
            let el = document.querySelectorAll('.single-list .el-table__body-wrapper > table > tbody');
            _this.sortable = Sortable.create(el[el.length - 1], {
                ghostClass: 'sortable-ghost',
                setData: function(dataTransfer) {
                    dataTransfer.setData('Text', '');
                },
                onEnd: evt => {
                    let sortTableData = [];

                    if (this.lazyloading) {
                        sortTableData = this.$util.clone(this.tableData);
                    } else {
                        sortTableData = this.$util.clone(this.formatData);
                    }
                    let tempIndex = sortTableData.splice(evt.oldIndex, 1)[0];
                    sortTableData.splice(evt.newIndex, 0, tempIndex);
                    _this.$emit('getSortData', evt.oldIndex, evt.newIndex, sortTableData);
                }
            });
        },
        // 设置选中的方法
        _setSelectRow() {
            if (!this.multipleSelectionAll || this.multipleSelectionAll.length <= 0 || !this.hasPageMemory) {
                //this.checkAll = false;
                this.isIndeterminate = false;
                return;
            }
            // 标识当前行的唯一键的名称
            let rowKey = this.rowKey;
            let selectAllIds = [];
            this.multipleSelectionAll.forEach(row => {
                selectAllIds.push(row[rowKey]);
            });
            this.$refs.elTableRef.clearSelection();
            let selectNum = 0;
            let dataNum = 0;
            if (this.lazyloading) {
                dataNum = this.tableData.length;
                for (let i = 0; i < this.tableData.length; i++) {
                    if (selectAllIds.indexOf(this.tableData[i][rowKey]) >= 0) {
                        this.$refs.elTableRef.toggleRowSelection(this.tableData[i], true);
                        selectNum++;
                    }
                }
            } else {
                dataNum = this.formatData.length;
                for (let i = 0; i < this.formatData.length; i++) {
                    if (selectAllIds.indexOf(this.formatData[i][rowKey]) >= 0) {
                        this.$refs.elTableRef.toggleRowSelection(this.formatData[i], true);
                        selectNum++;
                    }
                }
            }
            if (selectNum == 0) {
                //修改全选checkbox 的不确定状态
                this.checkAll = false;
                this.isIndeterminate = false;
            } else {
                if (selectNum == dataNum) {
                    //修改全选checkbox 的不确定状态
                    this.checkAll = true;
                    this.isIndeterminate = false;
                }
                if (selectNum < dataNum) {
                    //修改全选checkbox 的不确定状态
                    this.checkAll = false;
                    this.isIndeterminate = true;
                }
            }
        },
        /* 当某一行被点击时会触发该事件 */
        _handRowClick(row, column, event) {
            this.$emit('rowClick', row, column, event);
        },
        /* 当某一行被双击时会触发该事件 */
        _handRowDblclick(row, even) {
            this.$emit('rowDblclick', row, even);
        },
        /* 选择后实时回调父组件，selection所有选择行信息，row当前最新选中行信息 */
        _handleSelect(selection, row) {
            this.multipleSelection = selection;
            this._changePageCoreRecordData();
            this.$emit('handleSelect', selection, row);
        },
        /* 选择后实时回调父组件，selection所有选择行信息 */
        _handleSelectAll(selection) {
            this.multipleSelection = selection;
            this._changePageCoreRecordData();
            this.$emit('handleSelectAll', selection);
        },
        /* 当选择项发生变化时会触发该事件 */
        _handSelectionChange(selection) {
            this.multipleSelection = selection;
            // this._changePageCoreRecordData();
            this.$emit('handleSelectAll', selection);
            this.$emit('selectionChange', selection);
        },
        /* 为父组件提供所有选择的行信息 */
        getSelectAllRows() {
            if (this.hasPageMemory) {
                return this.multipleSelectionAll;
            }
            return this.multipleSelection;
        },
        /* 清空翻页记忆的数组 */
        clearSelectAllRows() {
            this.multipleSelectionAll = [];
        },
        /* 用于多选表格，清空用户的选择 */
        clearSelection() {
            this.$refs.elTableRef.clearSelection();
        },
        /* 用于多选表格，切换某一行的选中状态，如果使用了第二个参数，则是设置这一行选中与否（selected 为 true 则选中） */
        toggleRowSelection(row, selected) {
            this.$refs.elTableRef.toggleRowSelection(row, selected);
        },
        /* 用于多选表格，切换所有行的选中状态 */
        toggleAllSelection() {
            this.$refs.elTableRef.toggleAllSelection();
        },
        /* 当单元格 hover 进入时会触发该事件 */
        _handCellMouseEnter(row, column, cell, event) {
            this.$emit('cellMouseEnter', row, column, cell, event);
        },
        /* 当单元格 hover 退出时会触发该事件 */
        _handCellMouseLeave(row, column, cell, event) {
            this.$emit('cellMouseLeave', row, column, cell, event);
        },
        /* 当某个单元格被点击时会触发该事件 */
        _handCellClick(row, column, cell, event) {
            this.$emit('cellClick', row, column, cell, event);
        },
        /* 当某个单元格被双击击时会触发该事件 */
        _handCellDblclick(row, column, cell, event) {
            this.$emit('cellDblclick', row, column, cell, event);
        },
        /* 当某一行被鼠标右键点击时会触发该事件 */
        _handRowContextmenu(row, column, event) {
            this.$emit('rowContextmenu', row, column, event);
        },
        /* 当表格的当前行发生变化的时候会触发该事件 */
        _handCurrentChange(currentRow, oldCurrentRow) {
            this.$emit('currentChange', currentRow, oldCurrentRow);
        },
        // 记忆选择核心方法
        _changePageCoreRecordData() {
            // 标识当前行的唯一键的名称
            let rowKey = this.rowKey;
            let that = this;
            // 如果总记忆中还没有选择的数据，那么就直接取当前页选中的数据，不需要后面一系列计算
            if (this.multipleSelectionAll.length <= 0) {
                this.multipleSelectionAll = this.$util.clone(this.multipleSelection);
                this.updatedCheckStatus();
                return;
            }
            // 总选择集合里面的key集合
            let selectAllIds = [];
            this.multipleSelectionAll.forEach(row => {
                if (row[rowKey]) {
                    selectAllIds.push(row[rowKey]);
                }
            });
            let selectIds = [];
            // 获取当前页选中的id
            that.multipleSelection.forEach(row => {
                selectIds.push(row[rowKey]);
                // 如果总选择集合里面不包含当前页选中的数据，那么就加入到总选择集合里
                if (selectAllIds.indexOf(row[rowKey]) < 0 && row[rowKey]) {
                    that.multipleSelectionAll.push(row);
                }
            });

            let noSelectIds = [];
            // 得到当前页没有选中的id
            if (this.lazyloading) {
                that.tableData.forEach(row => {
                    if (selectIds.indexOf(row[rowKey]) < 0) {
                        noSelectIds.push(row[rowKey]);
                    }
                });
            } else {
                that.formatData.forEach(row => {
                    if (selectIds.indexOf(row[rowKey]) < 0) {
                        noSelectIds.push(row[rowKey]);
                    }
                });
            }
            noSelectIds.forEach(id => {
                if (selectAllIds.indexOf(id) >= 0) {
                    for (let i = 0; i < that.multipleSelectionAll.length; i++) {
                        if (that.multipleSelectionAll[i][rowKey] === id) {
                            // 如果总选择中有未被选中的，那么就删除这条
                            that.multipleSelectionAll.splice(i, 1);
                            break;
                        }
                    }
                }
            });
            this.updatedCheckStatus();
        },
        //更新全选状态
        updatedCheckStatus() {
            let that = this;
            if (that.multipleSelectionAll.length == 0) {
                //修改全选checkbox 的不确定状态
                that.checkAll = false;
                that.isIndeterminate = false;
            } else {
                let tableDataCount = 0;
                if (that.lazyloading) {
                    tableDataCount = that.tableData.length;
                } else {
                    tableDataCount = that.formatData.length;
                }
                if (that.multipleSelectionAll.length == tableDataCount) {
                    //修改全选checkbox 的不确定状态
                    that.checkAll = true;
                    that.isIndeterminate = false;
                }
                if (that.multipleSelectionAll.length < tableDataCount) {
                    //修改全选checkbox 的不确定状态
                    //that.$refs.checkBokRef.indeterminate = true;
                    that.isIndeterminate = true;
                    that.checkAll = false;
                }
            }
        },
        /* 全选 */
        allSelect(value) {
            if (value) {
                this.$refs.elTableRef.toggleAllSelection();
                this.checkAll = true;
                this.isIndeterminate = false;
            } else {
                this.$refs.elTableRef.clearSelection();
                this.multipleSelection = [];
                this.multipleSelectionAll = [];
                //修改全选checkbox 的不确定状态
                this.checkAll = false;
                this.isIndeterminate = false;
            }
        },
        /* 整合请求参数 */
        getParams() {
            let params = {};
            if (!this.$util.isEmpty(this.params)) {
                params = this.$util.clone(this.params);
            }
            params.pageSize = this.pageSize;
            params.currentPage = this.scrollPage;
            if (this.lazyloading) {
                params.needPage = true;
            } else {
                params.needPage = this.hasPage;
            }

            params.flag = true;
            return params;
        },
        /* 获取单列表数据 */
        getTableData() {
            let params = this.getParams();
            if (this.calInternal) {
                // 使用组件内部方法获取列表数据
                this.queryData(params);
            } else {
                this.$emit('queryData', params);
            }
        },
        /* 调用查询接口  */
        queryData(item) {
            let queryUrl = '';
            if (this.interfaceName == null || this.interfaceName.query == '') {
                this.$log.error("this.interfaceName.query == ''");
                return;
            }
            queryUrl = this.interfaceName.query;
            window.vue.$apiAxios.postRequestBody(
                queryUrl,
                JSON.stringify(item),
                response => {
                    if (response.status === this.$common.login.RESPONSE_STATUS && response.data && response.data.statusCode === this.$common.requestCode.SUCCESS_INFO_CODE) {
                        if (this.$util.isEmpty(response.data.content)) {
                            this.$log.error('tdSingleList/queryData/response.data.content-------is error', response.data);
                        } else {
                            let tableNewData = response.data.content;
                            if (item.flag) {
                                //如果是flag=true，则拼接数组。
                                this.tableData.push(...tableNewData);
                                if (tableNewData.length === 0) {
                                    this.busy = true;
                                } else {
                                    this.busy = false;
                                }
                            } else {
                                this.tableData = tableNewData;
                                this.busy = false;
                                //第一次进来的时候，把busy置位false。执行loadmore的方法
                            }
                        }
                    } else {
                        this.$log.error('tdSingleList/queryData---------staus is error', response.status);
                    }
                },
                null,
                null,
                this.token
            );
        },
        /* 搜索逻辑处理 */
        requestdata() {
            let params = this.getParams();
            params.caption = this.filterText;
            if (this.calInternal) {
                this.querySearchData(params);
            } else {
                this.$emit('querySearchData', params);
            }
        },
        /* 搜索数据请求处理 */
        querySearchData: function(param) {
            let queryUrl = '';
            if (this.interfaceName == null || this.interfaceName.search == '') {
                this.$log.error("this.interfaceName.search == ''");
                return;
            }
            queryUrl = this.interfaceName.search;
            let that = this;
            window.vue.$apiAxios.postRequestBody(
                queryUrl,
                JSON.stringify(param),
                response => {
                    if (response.status === this.$common.login.RESPONSE_STATUS && response.data && response.data.statusCode === this.$common.requestCode.SUCCESS_INFO_CODE) {
                        if (this.$util.isEmpty(response.data.content)) {
                            this.$log.error('tdSingleList/querySearchData/response.data.content-------is error', response.data);
                        } else {
                            let tableNewData = response.data.content;
                            if (param.flag) {
                                that.tableData.push(...tableNewData);
                                //如果是flag=true，则拼接数组。
                                if (tableNewData.length === 0) {
                                    this.busy = true;
                                } else {
                                    this.busy = false;
                                }
                            } else {
                                this.tableData = tableNewData;
                                this.busy = false;
                                //第一次进来的时候，把busy置位false。执行loadmore的方法
                            }
                        }
                    } else {
                        this.$log.error('tdSingleList/querySearchData---------staus is error', response.status);
                    }
                },
                null,
                null,
                this.token
            );
        },
        //滚动到底部时自动执行加载方法
        scrollLoad() {
            //是懒加载列表启用滚动加载功能
            if (this.lazyloading) {
                //把busy置位true，这次请求结束前不再执行
                this.busy = true;
                if (this.inputShow && this.filterText) {
                    //启用授权功能且搜索关键字不为空
                    this.requestdata();
                } else {
                    this.getTableData();
                }
                this.scrollPage++;
            }
        },
        //添加单列表数据
        btnAddElement() {
            if (this.hasAddElement) {
                this.$emit('addElement');
            }
        },
        /* 列表数据添加、修改、删除 */
        updateTableData(operation, value) {
            if (operation === 'add') {
                this.add(value);
            }
            if (operation === 'modify') {
                this.edit(value);
            }
            if (operation === 'delete') {
                this.delete(value);
            }
        },
        /* 添加列表数据 */
        add(addValue) {
            if (this.lazyloading) {
                this.tableData.push(addValue);
            } else {
                this.formatData.push(addValue);
            }
        },
        /* 修改列表数据添加 */
        edit(editValue) {
            let _this = this;
            if (this.lazyloading) {
                _this.tableData.splice(_this.tableData.findIndex(value => value[_this.columnObj.id] === editValue[_this.columnObj.id]), 1, editValue);
            } else {
                _this.formatData.splice(_this.formatData.findIndex(value => value[_this.columnObj.id] === editValue[_this.columnObj.id]), 1, editValue);
            }
        },
        /* 删除列表数据 */
        delete(deletValueId) {
            let _this = this;
            if (this.lazyloading) {
                _this.tableData.splice(_this.tableData.findIndex(value => value[_this.columnObj.id] === deletValueId), 1);
            } else {
                _this.formatData.splice(_this.formatData.findIndex(value => value[_this.columnObj.id] === deletValueId), 1);
            }
        },
        /* 当前页改变时触发的事件 */
        /* 父组件通过绑定该事件进行参数传递
        如：v-on:currentChange="currentChange1" currentChange对应部件方法部件方法名，currentChange1为父组件对应方法名 */
        _pagCurrentChange(val) {
            this._setSelectRow();
            this.$emit('pagCurrentChange', val);
        }
    }
};
</script>
<style scoped>
.conshow {
    overflow-x: auto;
    overflow-y: auto;
    margin-top: 5px;
    margin-left: 10px;
    margin: 0 auto;
}
>>> .el-table th > .cell {
    text-align: left !important;
}
>>> .el-table td,
.el-table th {
    height: 25px !important;
}
.singleListDiv {
    width: 265px;
    height: 350px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
    margin-bottom: 20px;
    -webkit-user-select: none;
    /* -moz-user-select: none;
    -ms-user-select: none; */
}
>>> svg.circular {
    width: 20px !important;
}
</style>
